export const PHONE_NUMBER_PATERN = new RegExp("([0-9]{10,11}|^$)");
